exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification{padding:0 50px 30px;display:flex;justify-content:center}@media screen and (max-width:768px){.notification{padding:0 10px 30px;display:flex;justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9aaf8b78","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lightbox/PasswordReset.vue
// module id = 251
// module chunks = 0